"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MegaMenuMobile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const index_1 = require("../index");
const index_2 = require("./index");
const context_1 = require("../../context");
const typings_1 = require("../../typings");
const MegaMenuMobile = () => {
    const breakpoints = (0, app_1.useBreakpoints)();
    const { dictionary, selectedMegaMenuItem, setSelectedMegaMenuIndex, setIsMenuMobileOpen, isMenuMobileOpen, setActivePopup, } = React.useContext(context_1.HeaderContext);
    const itemType = selectedMegaMenuItem === null || selectedMegaMenuItem === void 0 ? void 0 : selectedMegaMenuItem.type;
    React.useEffect(() => {
        if (breakpoints.md && isMenuMobileOpen) {
            setIsMenuMobileOpen(false);
        }
        else if (!breakpoints.md && selectedMegaMenuItem) {
            setIsMenuMobileOpen(true);
        }
    }, [breakpoints.md]);
    const handleOpenChange = (isOpen) => {
        if (isOpen) {
            setActivePopup(null);
        }
        setIsMenuMobileOpen(isOpen);
        if (!isOpen) {
            setSelectedMegaMenuIndex(null);
        }
    };
    const megaMenuMobileContent = React.useMemo(() => {
        switch (itemType) {
            case undefined:
            case typings_1.MegaMenuItemEnum.ZeroLevel:
                return (0, jsx_runtime_1.jsx)(index_2.MegaMenuMobileMain, {});
            case typings_1.MegaMenuItemEnum.Products:
                return (0, jsx_runtime_1.jsx)(index_2.MegaMenuMobileProducts, {});
            case typings_1.MegaMenuItemEnum.SingleLevel:
            case typings_1.MegaMenuItemEnum.SingleLevelWithIcons:
                return (0, jsx_runtime_1.jsx)(index_2.MegaMenuMobileSingleLevel, {});
            case typings_1.MegaMenuItemEnum.MultipleLevel:
                return (0, jsx_runtime_1.jsx)(index_2.MegaMenuMobileMultipleLevel, {});
            default:
                return null;
        }
    }, [itemType]);
    return ((0, jsx_runtime_1.jsxs)(index_1.HeaderPopup, { open: isMenuMobileOpen, onOpenChange: handleOpenChange, children: [(0, jsx_runtime_1.jsx)(index_1.HeaderPopup.Trigger, { "aria-label": dictionary.menuOpen, className: `${isMenuMobileOpen ? 'bg-brand-primary-pressed' : 'bg-brand-primary'} hover:bg-brand-primary-hovered text-inverse rounded-[10px] p-[10px] min-h-11 min-w-11`, children: isMenuMobileOpen ? (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "close" }) : (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "menu" }) }), (0, jsx_runtime_1.jsx)(index_1.HeaderPopup.Content, { popupClassName: "max-md:!px-0", children: (0, jsx_runtime_1.jsx)("nav", { className: "w-full overflow-y-auto", children: megaMenuMobileContent }) })] }));
};
exports.MegaMenuMobile = MegaMenuMobile;
